/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AnsweredCommentsContainer_story = {
    readonly id: string;
    readonly featuredComments: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"AnsweredCommentContainer_comment">;
            };
        }>;
    };
    readonly isClosed: boolean;
    readonly " $fragmentRefs": FragmentRefs<"PostCommentFormContainer_story" | "AnsweredCommentContainer_story" | "ViewersWatchingContainer_story">;
    readonly " $refType": "AnsweredCommentsContainer_story";
};
export type AnsweredCommentsContainer_story$data = AnsweredCommentsContainer_story;
export type AnsweredCommentsContainer_story$key = {
    readonly " $data"?: AnsweredCommentsContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"AnsweredCommentsContainer_story">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [
            {
                "defaultValue": 5,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "defaultValue": "CREATED_AT_DESC",
                "kind": "LocalArgument",
                "name": "orderBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": [
                        "featuredComments"
                    ]
                }
            ]
        },
        "name": "AnsweredCommentsContainer_story",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": "featuredComments",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "orderBy",
                        "variableName": "orderBy"
                    }
                ],
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "__Stream_featuredComments_connection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__typename",
                                        "storageKey": null
                                    },
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "AnsweredCommentContainer_comment"
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isClosed",
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PostCommentFormContainer_story"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AnsweredCommentContainer_story"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ViewersWatchingContainer_story"
            }
        ],
        "type": "Story",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '657ca0ff82e558b19e3169b48b2dede9';
export default node;
